<div class="w-[380px] rounded-md p-6 box-border h-full bg-shui-base-2">
    <sh-stepper [attr.value]="currentStepIndex() + 1" vertical [attr.readonly]="true">
        @for (step of steps(); track $index; let index = $index) {
            <sh-stepper-item
                [attr.label]="step.title | translate"
                [attr.info]="step.description | translate"
                [attr.type]="stepType(index)"
                [attr.disabled]="maxReachedStepIndex() < index ? true : null"
            ></sh-stepper-item>
        }
    </sh-stepper>
</div>
